import http from "./http";

export default {
  http,
  product_image_path: process.env.REACT_APP_PRODUCT_IMAGE_PATH
};
